import { jsx } from "react/jsx-runtime";
import { LocalizationProvider as LocalizationProviderMui } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar as DateCalendarMui } from "@mui/x-date-pickers/DateCalendar";
import { useMemo } from "react";
import { notReachable } from "../../shared/helpers";
import { CALENDAR_TYPE, useDateCalendarSlots } from "./shared";
const DateCalendar = ({
  locale,
  className,
  type = CALENDAR_TYPE.single,
  ...props
}) => {
  const { calendarPickerSlots, calendarPickerSlotsProps } = useDateCalendarSlots(type, props);
  const renderDateCalendar = useMemo(
    () => {
      switch (type) {
        case CALENDAR_TYPE.single:
          return /* @__PURE__ */ jsx(
            DateCalendarMui,
            {
              className,
              showDaysOutsideCurrentMonth: true,
              ...props,
              slots: calendarPickerSlots,
              slotProps: calendarPickerSlotsProps
            }
          );
        case CALENDAR_TYPE.week:
          return /* @__PURE__ */ jsx(
            DateCalendarMui,
            {
              className,
              showDaysOutsideCurrentMonth: true,
              ...props,
              slots: calendarPickerSlots,
              slotProps: calendarPickerSlotsProps
            }
          );
        case CALENDAR_TYPE.month:
          return /* @__PURE__ */ jsx(
            DateCalendarMui,
            {
              className,
              showDaysOutsideCurrentMonth: true,
              ...props,
              slots: calendarPickerSlots,
              slotProps: calendarPickerSlotsProps
            }
          );
        default:
          notReachable(type);
      }
    },
    [type, locale, props]
  );
  return locale ? /* @__PURE__ */ jsx(
    LocalizationProviderMui,
    {
      dateAdapter: AdapterDayjs,
      adapterLocale: locale,
      children: renderDateCalendar
    }
  ) : renderDateCalendar;
};
DateCalendar.displayName = "DateCalendar";
var DateCalendar_default = DateCalendar;
export {
  DateCalendar_default as default
};
